import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Card } from '../../pages/Theme';
import QuickPoll from "../../pages/Journal/QuickPoll";

const ModalQuickPoll = ({ showModalFeature, setshowModalFeature, quickPollContent, updatedData }) => {
    const reflectionFeedbackModel = useSelector((state) => state.reflectionFeedbackReducer?.reflectionFeedback?.reflection || []);
    const showHideModal = showModalFeature
        ? 'block'
        : 'hidden'
    return (
        <div className={showHideModal} >
            <div className="fixed inset-0 modelIndex flex items-center justify-center bg-black bg-opacity-50 px-4 py-6">
                <div className={`relative cardBackgroundColor rounded-xl shadow-md p-4 max-w-full max-h-screen overflow-auto top-2 bottom-2 right-2 left-2 modal-popup-width`}>
                    <div className="flex gap-2 items-center justify-center">
                        <p className="font-semibold blackColor text-center">Quick Poll ({reflectionFeedbackModel?.filter(x => x.id == quickPollContent[0]?.model_id)[0]?.display_name})</p>
                    </div>
                    {(quickPollContent && quickPollContent.length != 0) && <QuickPoll data={quickPollContent} updatedData={updatedData} isOpenQuickPoll={showModalFeature} />}
                </div>
            </div>
        </div>
    )
}

export default ModalQuickPoll